import Vue from "vue";
const moment = require("moment");
import axios from "axios";
import store from "../store";
import auth from "./auth";
import PortalVue from "portal-vue";
import VueMeta from "vue-meta";
import VueClipboard from "vue-clipboard2";
import VueCarousel from "vue-carousel";
import { version } from "../../package.json";
import InfiniteScroll from "vue-infinite-scroll";
import metaDataInfo from "./metaDataInfo";
import Vue2TouchEvents from "vue2-touch-events";
import analyticsPlugin from "./eventAnalytics/plugin";
import featureFlagsMixin from './mixins/featureFlags.mixin';
import miniAppDeposit from './miniappDeposit'

import {
	cookie,
	getParameterByName,
	getAppSource,
	focusAndOpenKeyboard,
	validatePhoneNumber,
	formatMobile,
	getNumberPrefix,
	getPrefixCountry,
	getUrlSlug,
	validateStrongPassword,
	getStrongPasswordRules
} from "./index";
const analytics = require("./analytics").default;

import VueTour from "vue-tour";
require("vue-tour/dist/vue-tour.css");

if (
	process.env.NODE_ENV === "production" ||
	process.env.NODE_ENV === "staging"
) {
	const { registerServiceWorker } = require("../assets/scripts/pwa");
	registerServiceWorker()
		.then((registration) => (Vue.prototype.$swRegistration = registration))
		.catch((error) => (Vue.prototype.$swRegistration = null));
}

const RegisterPrototypes = () => {
	return new Promise((resolve, reject) => {
		const notifications = require("./notifications").default;

		// Services
		Vue.use(VueClipboard);
		Vue.use(PortalVue);
		Vue.use(VueMeta);
		Vue.use(VueCarousel);
		Vue.use(InfiniteScroll);
		Vue.mixin(featureFlagsMixin); // Feature flag mixin here globally
		Vue.prototype.$tracking = analytics;
		Vue.prototype.$trackAnalytics = analyticsPlugin;
		Vue.prototype.$notifications = notifications;
		Vue.prototype.$axios = axios;
		Vue.prototype.$store = store;
		Vue.prototype.$version = version;
		Vue.prototype.$auth = auth;
		Vue.prototype.$cookie = cookie;
		Vue.prototype.$moment = moment;
		Vue.prototype.$metaDataInfo = metaDataInfo;
		Vue.prototype.$miniappDeposit = miniAppDeposit;
		const utils = {
			cookie,
			getParameterByName,
			getAppSource,
			focusAndOpenKeyboard,
			validatePhoneNumber,
			formatMobile,
			getNumberPrefix,
			getPrefixCountry,
			getStrongPasswordRules,
			validateStrongPassword,
		};
		window.utils = utils;
		Vue.prototype.$utils = utils;
		String.prototype.capitalize = function () {
			return this.replace(/(?:^|\s)\S/g, function (a) {
				return a.toUpperCase();
			});
		};
		String.prototype.isMatch = function (regex) {
			return this.match(regex) !== null;
		};

		String.prototype.isMatch = function (regex) {
			return this.match(regex) !== null;
		};

		String.prototype.getUrlSlug = function () {
			return getUrlSlug(this);
		};

		// Variables
		let isOPR = window.navigator.userAgent.indexOf("OPR") > -1;
		let isSDV2 = window.location.search.toLowerCase().indexOf("sdv2") > -1;
		let closedLiteBanner = cookie.get("closed_lite_banner");
		window.isAndroid = navigator.userAgent.match(/Android/i) ? true : false;
		Vue.prototype.isAndroid = navigator.userAgent.match(/Android/i)
			? true
			: false;
		if ((isOPR || isSDV2) && !closedLiteBanner) {
			window.isAndroid = true;
			Vue.prototype.isAndroid = true;
		}
		window.canShowAndroidBanner =
			(localStorage.hasOwnProperty("showAndroidBanner")
				? JSON.parse(localStorage.showAndroidBanner)
				: false) && window.isAndroid;
		Vue.prototype.canShowAndroidBanner =
			(localStorage.hasOwnProperty("showAndroidBanner")
				? JSON.parse(localStorage.showAndroidBanner)
				: false) && window.isAndroid;

		window.isPWA = getParameterByName("utm_source") == "pwa";
		window.isSafari = /^((?!chrome|android).)*safari/i.test(
			navigator.userAgent
		);
		Vue.prototype.isSafari = /^((?!chrome|android).)*safari/i.test(
			navigator.userAgent
		);

		Vue.prototype.arrayInsertAt = (arr, index, newItem) => [
			...arr.slice(0, index),

			...newItem,

			...arr.slice(index),
		];

		// Configure axios
		axios.defaults.headers.post["Content-Type"] =
			"application/x-www-form-urlencoded";

		Vue.use(Vue2TouchEvents);

		Vue.use(VueTour);

		// Long Press Implementation
		Vue.directive("longpress", {
			bind: function (el, binding, vNode) {
				// Make sure expression provided is a function
				if (typeof binding.value !== "function") {
					// Fetch name of component
					const compName = vNode.context.name;
					// pass warning to console
					let warn = `[longpress:] provided expression '${binding.expression}' is not a function, but has to be`;
					if (compName) {
						warn += `Found in component '${compName}' `;
					}

					console.warn(warn);
				}

				// Define variable
				let pressTimer = null;

				// Define funtion handlers
				// Create timeout ( run function after 2s )
				let start = (e) => {
					if (e.type === "click") {
						return;
					}

					if (pressTimer === null) {
						pressTimer = setTimeout(() => {
							// Run function
							handler();
						}, 500);
					}
				};

				// Cancel Timeout
				let cancel = (e) => {
					// Check if timer has a value or not
					if (pressTimer !== null) {
						clearTimeout(pressTimer);
						pressTimer = null;
					}

					if (e.type === "click") {
						e.stopPropagation();
						e.preventDefault();
						e.stopImmediatePropagation();
						return false;
					}
				};
				// Run Function
				const handler = (e) => {
					binding.value(e);
				};

				// Add Event listeners
				el.addEventListener("mousedown", start);
				el.addEventListener("touchstart", start);
				// Cancel timeouts if this events happen
				el.addEventListener("click", cancel);
				el.addEventListener("mouseout", cancel);
				el.addEventListener("touchend", cancel);
				el.addEventListener("touchcancel", cancel);
			},
		});

		axios.interceptors.response.use(
			function (response) {
				return response;
			},
			function (error) {
				if (error.response) {
					try {
						decibelInsight("sendHTTPError", error.response.status);
					} catch (e) {}
				}
				// Do something with response error
				return Promise.reject(error);
			}
		);
		resolve(true);
	});
};

export { RegisterPrototypes };
